import { getPercentage } from "common/utils/commonUtilities";

/**
 * Calculate percentage change between current and previous values
 * Handles edge cases for zero values
 */
export const getCalculatedPercentage = (currentValue, previousValue) => {
  const current = parseFloat(currentValue) || 0;
  const previous = parseFloat(previousValue) || 0;

  if (previous === 0 && current > 0) {
    return 100;
  }

  if (previous > 0 && current === 0) {
    return -100;
  }

  if (current === 0 && previous === 0) {
    return 0;
  }

  return getPercentage(current, previous);
};

/**
 * Format currency amount with currency code
 */
export const formatCurrency = (amount, currencyCode = "AUD") => {
  const formattedAmount = amount ? (amount / 100).toFixed(2) : "0.00";
  return `${currencyCode} ${formattedAmount}`;
};

/**
 * Calculate sent messages (total - received - blocked)
 */
export const calculateSentMessages = data => {
  if (!data) return 0;
  return Number(data.totalSMS) - Number(data.totalSMSReceived) - Number(data.totalSMSBlocked);
};

/**
 * Format percentage for display
 */
export const formatPercentage = percentage => {
  return `${percentage > 0 ? "+" : ""}${percentage.toFixed(2)}%`;
};
